import { object, string } from '@gogame/schemas';

import {
  TYPE,
  PERIOD,
  DESCRIPTION,
  NETWORKS,
} from 'scenes/Annotations/constants';

export const annotationSchema = object({
  [PERIOD]: string().required('Period is required'),
  [TYPE]: string().required('Type is required'),
  [DESCRIPTION]: string().required('Description is required'),
});

export const subTypesParamsSchema = object({
  [TYPE]: string().required(),
});

export const clustersParamsSchema = object({
  [NETWORKS]: string().required(),
});
